/**
 * Copyright © 2026 Adnuntius AS.
 */
import Quill from 'quill';

const icons = Quill.import('ui/icons') as Record<string, any>;

icons.undo = '<i class="fa fa-undo"></i>';
icons.redo = '<i class="fa fa-repeat"></i>';
icons.html = '<i class="fa fa-code"></i>';
icons.paragraph = 'P';

if (!icons.header || typeof icons.header === 'string') {
  icons.header = {};
}
icons.header['3'] = 'H3';
icons.header['4'] = 'H4';

const QUILL_TOOLBAR_MAP: Record<string, string | Record<string, string | number>> = {
  h1: {header: 1},
  h2: {header: 2},
  h3: {header: 3},
  h4: {header: 4},
  p: 'paragraph',
  bold: 'bold',
  italics: 'italic',
  strikeThrough: 'strike',
  ul: {list: 'bullet'},
  ol: {list: 'ordered'},
  redo: 'redo',
  undo: 'undo',
  clear: 'clean',
  insertImage: 'image',
  insertLink: 'link',
  html: 'html'
};

export function buildQuillModules(
  toolbar: string[][],
  handlers: Record<string, (...args: any[]) => void>
): Record<string, any> {
  const container = toolbar.map((group) => group.map((action) => QUILL_TOOLBAR_MAP[action] || action));

  return {
    toolbar: {
      container,
      handlers: {
        undo(this: {quill: any}) {
          this.quill.history.undo();
        },
        redo(this: {quill: any}) {
          this.quill.history.redo();
        },
        paragraph(this: {quill: any}) {
          this.quill.format('header', false);
        },
        ...handlers
      }
    }
  };
}
